import { Box, Typography } from "@mui/joy";
import moment from "moment";
import { Helmet } from "react-helmet";
import { ActionsRequired } from "../hooks/actionsRequired/actionsRequired";
import { UpcomingServices } from "../hooks/upcomingServices/upcomingServices";
import { useMyMember } from "../redux/member/memberHooks";

/**
 *
 * @returns {ReactElement} Journal page
 */
export function Journal() {
  const { member } = useMyMember();
  const hour = new Date().getHours();
  const greeting =
    hour < 12 ? "Good morning" : hour < 18 ? "Good afternoon" : "Good evening";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        width: "100vw",
        position: "relative",
        maxWidth: 1000,
        margin: "0 auto",
        p: { xs: 2, md: 3 },
        pt: { xs: 2, md: 4 },
        gap: 1,
      }}
    >
      <Helmet>
        <title>Rhapsody | Journal</title>
      </Helmet>
      <Box>
        <Typography
          level="body2"
          sx={{
            color: "var(--mui-palette-text-secondary)",
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: "0.06em",
            fontSize: "0.75rem",
          }}
        >
          {moment().format("dddd, MMMM D")}
        </Typography>
        <Typography
          sx={{
            fontSize: "1.75rem",
            fontWeight: 700,
            letterSpacing: "-0.02em",
            lineHeight: 1.2,
          }}
        >
          {greeting}
          {member?.firstName ? `, ${member.firstName}` : ""}
        </Typography>
      </Box>
      <ActionsRequired />
      <UpcomingServices />
    </Box>
  );
}
